import {  useState } from 'react';
import { Button, TextField, Grid, Box, Typography, Alert, Stack, IconButton, } from '@mui/material';
import { formToJson } from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TermSelector from '../../fragement/TermSelector';
import { loadCategoryCourses } from '../../../Component/DataLoader';
import CourseCategorySelector from '../../fragement/CourseCategorySelector';
import { CourseSelect } from '../../fragement/CourseSelector';
import { MyTextField } from '../../../Component/MuiEx';

const EditPackageCourse = (props) => {
    const { data, onSubmit, onClose } = props
    const [fieldErrors, setFieldErrors] = useState()
    const [error, setError] = useState()   
    const [fields, setFields] = useState({})    
    // // const session = getUserSession(apis)
    // const hasChosen = (cid,ccid)=>{
    //     if(courses || courses.length == 0) return false
    //     for(let i=0;i<data.package_coures.length;i++) {
    //         if(courses[i].category_id == cid && courses[i].course_id == ccid && !courses[i].removed) {
    //             return true
    //         }
    //     }
    //     return false
    // }
    // const addToCourses = (row,price,tax,lessons,description) => {
    //     let cc = {id:0,package_id:data.id,category_id:row.id,course_id:row.course_id,}
    // }
    // const setupCategoryCourses = (data)=>{
    //     let dd = []
    //     data.map(item=>{
    //         let row = {id:item.id,name:item.name,course_id:0,code:item.code,target:item.target,added:false}
    //         if(hasChosen(item.id,0)) {
    //             row.added = true
    //         }
    //         dd.push(row)
    //         item.coures?.map(course=>{
    //             let row = {id:item.id,name:item.name,course_id:course.id,course:course,code:item.code,target:item.target,added:false}
    //             if(hasChosen(item.id,course.id)) {
    //                 row.added = true
    //             }
    //             dd.push(row)
    //         })
    //     })
    //     setCategories(dd)
    // }
    
    const handleChange = (n, v) => {
        setFields({ ...fields, [n]: v })
    }
    // const handleRemove = (idx)=>{
    //     let cc = [...courses]
    //     cc[idx].removed = true
    //     setCourses(cc)
    // }
    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id : 0
        Object.keys(fields).map(key => { postData[key] = fields[key] })
        //postData.passwd && postData.passwd.length>0 && (postData.passwd = hex_md5(postData.passwd))
        onSubmit && onSubmit(postData, setError, setFieldErrors)
    };
    // const TableHeader = [
    //     {name:"id",showName:"ID"},
    //     {name:"name",showName:"Category",func:(v,idx,row)=>{
    //         return v>0 ? <Stack direction={"row"}>
    //             <Typography variant='subtitle'>{row.course_category?.name}</Typography>
    //             <Typography variant='body2' sx={{color:"#8888"}}>{row.course_category?.code} | {row.course_category?.target}</Typography>
    //         </Stack>:"*"
    //     }},
    //     {name:"name",showName:"Course",func:(v,idx,row)=>{
    //         return v>0 ? <Stack direction={"row"}>
    //             <Typography variant='subtitle'>{row.course?.name}</Typography>
    //             <Typography variant='body2' sx={{color:"#8888"}}>{row.course?.code} | Level {row.course?.level} | {row.course?.lessonhours} hours</Typography>
    //         </Stack>:"*"
    //     }},
    //     {name:"option",showName:"",func:(v,idx,row)=>{
    //         return <IconButton aria-label="delete" onClick={handleRemove(idx)}><Delete /></IconButton>
    //     }}
    // ]
    // const TableHeader1 = [
    //     {name:"id",showName:"ID"},
    //     {name:"name",showName:"Course",func:(v,idx,row)=>{
    //         return v>0 ? <Stack direction={"row"}>
    //             <Typography variant='subtitle'>{row.cname}</Typography>
    //             <Typography variant='body2' sx={{color:"#8888"}}>{row.course_category?.code} | {row.course_category?.target}</Typography>
    //         </Stack>:"*"
    //     }},
    //     {name:"name",showName:"Course",func:(v,idx,row)=>{
    //         return v>0 ? <Stack direction={"row"}>
    //             <Typography variant='subtitle'>{row.course?.name}</Typography>
    //             <Typography variant='body2' sx={{color:"#8888"}}>{row.course?.code} | Level {row.course?.level} | {row.course?.lessonhours} hours</Typography>
    //         </Stack>:"*"
    //     }},
    //     {name:"option",showName:"",func:(v,idx,row)=>{
    //         return <IconButton aria-label="delete" onClick={handleRemove(idx)}><Delete /></IconButton>
    //     }}
    // ]
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Packaged Course</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <CourseCategorySelector defaultValue={fields.category_id} name={"category_id"} onChange={(n,v)=>handleChange(n,v?.id)} />
                        </Grid>
                        {fields.category_id > 0 && <Grid item xs={12} sm={6}>
                            <CourseSelect defaultValue={fields.course_id} categoryid={fields.category_id} name={"course_id"} onChange={(n,v)=>handleChange(n,v?.id)} />
                        </Grid>}                        
                        <Grid item xs={12} sm={12}>
                            <TermSelector name="term_id" label="Select Term" onChange={(n,v)=>handleChange(n,v?.id)} defaultValue={data?.term_id} />
                        </Grid> 
                        <Grid item xs={12} sm={6}>
                            <MyTextField required={true} fullWidth={true} defaultValue={0} id="lessons" label={"Lessons"} type="number" fieldErrors={fieldErrors}/>
                        </Grid> 
                        <Grid item xs={12} sm={6}>
                            <MyTextField required={true} fullWidth={true} defaultValue={0} id="lessonduration" label={"Lesson Minutes"} type="number" fieldErrors={fieldErrors}/>
                        </Grid> 
                        <Grid item xs={12} sm={6}>
                            <MyTextField required={true} fullWidth={true} defaultValue={0} id="price" label={"Lesson Price"} fieldErrors={fieldErrors}/>
                        </Grid>                
                        <Grid item xs={12} sm={6}>
                            <MyTextField required={true} fullWidth={true} defaultValue={0} id="tax" label={"Tax rate"} fieldErrors={fieldErrors}/>
                        </Grid>                                        
                        <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data?.description} multiline rows={6} name="description" required fullWidth id="description" label="description"
                                error={fieldErrors && fieldErrors.description ? true : false}
                                helperText={fieldErrors && fieldErrors.description ? fieldErrors.description : ''}
                                autoFocus />
                        </Grid>                        
                    </Grid>
                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                </Box>
            </Box>
        </Container>
    );
}
export default EditPackageCourse